import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { HeartPulse, Mail, X } from "lucide-react";
import { API } from "../../utils/api";
import { ReconnectDialog } from "./ReconnectDialog";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";

// System Pulse card: clients past their usual buying cycle (open retention alerts)
export const RetentionAlertsCard = ({ isEs, fmt }) => {
  const [alerts, setAlerts] = useState([]);
  const [reconnect, setReconnect] = useState(null);
  const navigate = useNavigate();
  const load = () => axios.get(`${API}/client-retention/alerts?status=open`, { withCredentials: true }).then((r) => setAlerts(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!alerts.length) return null;
  const dismiss = (id) => axios.post(`${API}/client-retention/alerts/${id}/dismiss`, {}, { withCredentials: true }).then(load).catch(() => {});
  return (
    <Card className="border-rose-300/50 bg-rose-50/40" data-testid="retention-alerts-card">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-lg flex items-center gap-2"><HeartPulse className="w-5 h-5 text-rose-500" />{isEs ? "Clientes enfriándose" : "Clients going quiet"} ({alerts.length})</CardTitle>
        <Button variant="ghost" size="sm" onClick={() => navigate("/business-clarity/retention")} data-testid="retention-alerts-view-all">{isEs ? "Ver todos" : "View all"}</Button>
      </CardHeader>
      <CardContent className="space-y-2">
        {alerts.slice(0, 5).map((a) => (
          <div key={a.alert_id} className="flex items-center justify-between gap-3 text-sm border-b last:border-0 pb-2" data-testid={`retention-alert-${a.alert_id}`}>
            <div><p className="font-medium">{a.client_name}</p>
              <p className="text-xs text-muted-foreground">{isEs ? `${a.days_since_last} días sin comprar · ciclo ${a.cycle_days} días` : `${a.days_since_last} days quiet · cycle ${a.cycle_days} days`}{a.owner_name ? ` · ${a.owner_name}` : ""} · {fmt(a.lifetime_revenue)}</p></div>
            <div className="flex items-center">
              <Button variant="ghost" size="icon" title={isEs ? "Enviar correo con oferta" : "Send offer email"} onClick={() => setReconnect(a)} data-testid={`retention-alert-reconnect-${a.alert_id}`}><Mail className="w-4 h-4" /></Button>
              <Button variant="ghost" size="icon" title={isEs ? "Descartar" : "Dismiss"} onClick={() => dismiss(a.alert_id)} data-testid={`retention-alert-dismiss-${a.alert_id}`}><X className="w-4 h-4" /></Button>
            </div>
          </div>
        ))}
      </CardContent>
      <ReconnectDialog alertId={reconnect?.alert_id} clientName={reconnect?.client_name} isEs={isEs} onClose={() => setReconnect(null)} onSent={load} />
    </Card>
  );
};
